import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
// import { Col, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
// import ScoreBoard from "../../components/ScoreBoard";
const Cookies = require("js-cookie");

const LobbyRoom: React.FC = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [dataRoom, setDataRoom] = useState<any>();
  const [coin, setCoin] = useState(0);
  const [loading, setLoading] = useState(false);
  // const [rateWin, setRateWin] = useState<number>();
  // const [isPlayer, setIsPlayer] = useState<string>();
  // const [image, setImage] = useState<string>();
  const [tableRound, setTableRound] = useState<any>();
  // const [shuffle, setShuffle] = useState<number | null>(null);
  // const [selectedKey, setSelectedKey] = useState<number | null>(1);
  const [renderKey, setRenderKey] = useState(0);
  const [showPredictionOverlay, setShowPredictionOverlay] = useState(false);
  const [predictionType, setPredictionType] = useState<'B' | 'P' | null>(null);
  const lastRoundCountRef = useRef<number>(0);

  const { id } = useParams();
  const token = Cookies.get("access_token");

  const userInfoString = localStorage.getItem("user_info");
  const navigate = useNavigate();

  useEffect(() => {
    if (dataRoom?.totalRound?.length) {
      axios
        .post(
          `${process.env.REACT_APP_URL_API}/users/subtract-coins-for-action`,
          {
            amount: 1,
            action: "PLAY_GAME",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((data) => setCoin(data.data.coins))
        .catch((err) => {
          if (
            err.status === 400 &&
            err.response.data.message ===
              "Số xu hiện tại không đủ để thực hiện hành động: PLAY_GAME"
          ) {
            Swal.fire({
              icon: "error",
              title: "Lỗi tải dữ liệu",
              text: err.response.data.message,
              customClass: {
                popup: "bg-custom-image text-white",
              },
            });
            navigate("/casino/lobby");
          }
        });
    }
  }, [dataRoom?.totalRound?.length, token, navigate]);

  if (userInfoString) {
    const userInfo = JSON.parse(userInfoString);

    userInfo.coins = coin;

    localStorage.setItem("user_info", JSON.stringify(userInfo));
  }

  useEffect(() => {
    if (dataRoom === undefined) {
      setLoading(true);
    }
    if (dataRoom) {
      setLoading(false);
    }
  }, [dataRoom]);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get(
          `${process.env.REACT_APP_URL_API_CASINO}/predict/get-table-by-name?tableName=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((data) => {
          const newData = data.data;
          const currentRoundCount = newData.totalRound?.length || 0;
          
          // Kiểm tra nếu có ván mới (số lượng round tăng lên)
          if (currentRoundCount > lastRoundCountRef.current && lastRoundCountRef.current > 0) {
            const roundFlag = (newData.percentCurrent?.Round ?? '').toString().toUpperCase();
            let prediction: 'B' | 'P';
            
            if (roundFlag === 'B') {
              prediction = 'B';
            } else if (roundFlag === 'P') {
              prediction = 'P';
            } else {
              prediction = (newData.percentCurrent?.Forecast ?? 0) > 50 ? 'B' : 'P';
            }
            
            setPredictionType(prediction);
            setShowPredictionOverlay(true);
            
            setTimeout(() => {
              setShowPredictionOverlay(false);
              setPredictionType(null);
            }, 5000);
          }
          
          // Set lastRoundCount sau khi check điều kiện
          lastRoundCountRef.current = currentRoundCount;
          // setRateWin(newData.percentCurrent.Forecast);
          // setIsPlayer(newData.percentCurrent.Round);
          setDataRoom(newData);
          setLoading(false);
          setRenderKey(prev => prev + 1); // Force re-render
        })
        .catch((err) => {
          setLoading(false);
          // Fallback data để tránh treo loading
          setDataRoom({
            totalRound: [],
            percentCurrent: { Forecast: 50 },
            groupRoad: { 
              total: { group: 0, win: 0, loss: 0 },
              table: []
            }
          });
        });
    };

    // Fetch ngay lập tức
    fetchData();
    
    // Polling mỗi 3 giây để update data mới
    const interval = setInterval(fetchData, 3000);

    return () => clearInterval(interval);
  }, [id, token]);

  useEffect(() => {
    if (dataRoom) {
      setTableRound(dataRoom?.ai0 ?? dataRoom?.groupRoad);
    }
  }, [dataRoom]);

  // const lengthArray = new Array(tableRound?.groupRoad?.table.length).fill(null);


  // let countDown = 0;

  // if (dataRoom?.statusGame === "GP_NEW_GAME_START") {
  //   const currentTime = dataRoom?.timeCurrent || DateTime.now().setZone("Asia/Ho_Chi_Minh", { keepLocalTime: false });
  //   const roundStartTime = dataRoom?.roundStartTime;
  //   const timePassed = currentTime - roundStartTime;
  //   const totalDuration = dataRoom?.iTime * 1000;
  //   const countDownUnix = Math.max(totalDuration - timePassed, 0);
  //   countDown = Math.floor(countDownUnix / 1000);
  // }

  return (
    <div className="min-h-screen relative overflow-x-hidden">
      {/* Desktop Video */}
      <video 
        className="fixed top-0 left-0 w-full h-full object-cover -z-10 hidden sm:block"
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/assets/bg-pc.mp4" type="video/mp4" />
      </video>
      
      {/* Mobile Video */}
      <video 
        className="fixed top-0 left-0 w-full h-full object-cover -z-10 block sm:hidden"
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/assets/bg-mb.mp4" type="video/mp4" />
      </video>
      
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="container mx-auto px-4 pt-8">
        {/* 1. Header với title và nút quay lại */}
        <div className="flex items-center justify-center mb-8 relative">
          <h1
            className="text-2xl md:text-5xl font-bold text-center"
            style={{
              background: 'linear-gradient(90deg, #000000 0%, #674000 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textShadow: '0px 2.49px 2.49px #FAAA16',
            }}
          >
            PHẦN MỀM TÍCH HỢP CÔNG THỨC BACCARAT
          </h1>
          <button
            type="button"
            className="back-cta absolute right-0 hidden sm:flex"
            onClick={() => navigate("/casino/lobby")}
          >
            <img
              src="/assets/arrow-back.png"
              alt="QUAY LẠI"
              className="back-cta-img"
            />
            <span className="back-cta-text">QUAY LẠI</span>
          </button>
        </div>

          {/* 2. Buttons sảnh và bàn */}
          <div className="flex justify-center gap-4 mb-8">
          <div 
            className="text-white px-6 py-3 rounded-xl shadow-lg border-2 border-yellow-400 font-bold text-lg"
            style={{ 
              background: 'linear-gradient(to bottom, #261700, #8F5C08)'
            }}
          >
            <span className="text-white font-bold text-lg">SẢNH: </span>
            <span className="text-yellow-400 font-bold text-lg">AE CASINO</span>
          </div>
          <div 
            className="text-white px-6 py-3 rounded-xl shadow-lg border-2 border-yellow-400 font-bold text-lg"
            style={{ 
              background: 'linear-gradient(to bottom, #261700, #8F5C08)'
            }}
          >
            <span className="text-white font-bold text-lg">BÀN: </span>
            <span className="text-yellow-400 font-bold text-lg">{id || '1'}</span>
          </div>
          </div>
          </div>


        <div className="room-lobby-3part-layout w-full max-w-[1550px] mx-auto">
        {loading ? (
          <div className="flex justify-center items-center min-h-screen">
            <div className="text-white text-xl">♠️ Đang tải dữ liệu trò chơi...</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-6">
            {/* Left side - Images */}
            <div className="lg:col-span-2 flex flex-col lg:flex-col items-center gap-6">
              {/* Mobile: Ảnh banker/player và percent nằm cùng hàng */}
              <div className="flex lg:flex-col items-center gap-4 lg:gap-6">
                {/* Ảnh banker/player */}
                <div className="flex justify-center">
                  {(() => {
                    const roundFlag = (dataRoom?.percentCurrent?.Round ?? '').toString().toUpperCase();
                    const isBanker = roundFlag === 'B' || (
                      !roundFlag && (dataRoom?.percentCurrent?.Forecast ?? 0) > 50
                    );
                    const altText = isBanker ? 'NHÀ CÁI' : 'PLAYER';
                    const src = isBanker ? '/assets/banker.gif' : '/assets/player.gif';
                    return (
                      <img src={src} alt={altText} className="w-36 h-36 lg:w-48 lg:h-48 object-contain" />
                    );
                  })()}
                </div>

                {/* Ảnh percent với số % */}
                <div className="relative lg:mt-12">
                  <img
                    src="/assets/percent.gif"
                    alt="Percent"
                    className="w-36 h-36 lg:w-48 lg:h-48 object-contain"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-[#fff] font-bold text-2xl lg:text-4xl">
                      {Math.round(dataRoom?.percentCurrent?.Forecast || 0)}%
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Center - Main content */}
            <div className="lg:col-span-7 flex flex-col items-center">
              {/* 3. Bảng baccarat với nền trắng kiểu caro */}
              <div 
                key={`baccarat-${renderKey}`}
                className="rounded-lg mb-6 border-2 border-gray-300 w-full max-w-full mx-auto"
                style={{
                  backgroundImage: 'url(/assets/caro-table.png)',
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#ffffff',
                  width: '100%',
                  height: 'auto',
                  aspectRatio: '855/203'
                }}
              >
                {(() => {
                  const rounds = dataRoom?.totalRound || [];
                  const rows = 6;
                  const cols = 20; // số cột hiển thị của ảnh nền caro
                  
                  // Responsive dimensions
                  const baseWidth = 855;
                  const baseHeight = 203;
                  const cellW = baseWidth / cols;
                  const cellH = baseHeight / rows;

                  // Lấy outcome từ backend
                  const detectOutcome = (item: any): 'B' | 'P' | 'T' | null => {
                    // 1) Tie counters/flags
                    if (typeof item.count === 'number' && item.count > 0) {
                      return 'T';
                    }
                    if (item.isTie === true || item.tie === true) {
                      return 'T';
                    }

                    // 2) Explicit flags for winner
                    if (item.banker === true || item.isBankerWin === true) {
                      return 'B';
                    }
                    if (item.player === true || item.isPlayerWin === true) {
                      return 'P';
                    }

                    // 3) Road code mapping if present
                    if (typeof item.road === 'number') {
                      if ([0,1,2].includes(item.road)) {
                        return 'B';
                      }
                      if ([8,9,10].includes(item.road)) {
                        return 'P';
                      }
                      return 'T';
                    }

                    // 4) String winners from various providers
                    const v = (item.type ?? item.result ?? item.winner ?? item.value ?? item.outcome ?? item.roundResult);
                    if (typeof v === 'string') {
                      const s = v.toUpperCase();
                      if (s === 'B') { return 'B'; }
                      if (s === 'P') { return 'P'; }
                      if (s === 'T') { return 'T'; }
                      if (s.includes('BANKER')) { return 'B'; }
                      if (s.includes('PLAYER')) { return 'P'; }
                      if (s.includes('TIE')) { return 'T'; }
                    }
                    return null;
                  };

                  const formatBaccaratResults = (results: any[]) => {
                    const formatted: any[] = [];
                    const occupied = new Set<string>(); // to handle collisions/push-right
                    const lastYByCol = new Map<number, number>(); // compressed column index -> last y
                    const colIndexByShowX = new Map<number, number>(); // raw showX -> compressed index
                    let nextColIndex = 0;
                    let lastType: 'B' | 'P' | null = null; // last non-tie type
                    let lastShowXRaw: number | null = null; // last non-tie raw showX
                    let lastColIndex: number | null = null; // last non-tie compressed column
                    // Edge-lock state
                    let edgeLockActive = false;
                    let edgePreferredRow: number | null = null; // 4=e,3=d,2=c,1=b,0=a
                    let edgeStartCol: number | null = null;
                    let edgeStartFilled = false;
                    

                    for (let i = 0; i < results.length; i++) {
                      const current = results[i];
                      const outcome = detectOutcome(current);
                      

                      // Tie: mark previous cell only
                      if (outcome === 'T' || (typeof current.count === 'number' && current.count > 0)) {
                        if (formatted.length > 0) {
                          const lastIndex = formatted.length - 1;
                          const last = formatted[lastIndex];
                          const baseType = (last.type as string).replace('-H', '') as 'B' | 'P';
                          const newType = (baseType === 'B' ? 'B-H' : 'P-H');
                          const newTieCount = (typeof last.tieCount === 'number' ? last.tieCount : 0) + 1;
                          formatted[lastIndex] = {
                            ...last,
                            type: newType,
                            isTie: true,
                            tieCount: newTieCount,
                          };
                          
                        }
                        continue;
                      }

                      // Decide compressed column index based on raw showX, with tie-lock override
                      const rawX: number = typeof current.showX === 'number' ? current.showX : (lastShowXRaw ?? 0);
                      const lastCell = formatted.length > 0 ? formatted[formatted.length - 1] : null;
                      const lastBaseType = lastCell ? (String(lastCell.type).replace('-H','')) as 'B'|'P' : null;
                      const tieLockActive = !!(lastCell && lastCell.isTie && (lastCell.tieCount ?? 0) >= 2 && lastBaseType);
                      const continuingStreak = (outcome === 'B' || outcome === 'P') && lastType !== null && outcome === lastType && lastColIndex !== null;
                      let colIndex: number;
                      if (tieLockActive && (outcome === lastBaseType)) {
                        colIndex = (lastColIndex ?? 0);
                        
                      } else if (tieLockActive && lastBaseType && (outcome !== lastBaseType) && lastColIndex !== null) {
                        colIndex = nextColIndex++;
                        colIndexByShowX.set(rawX, colIndex);
                        
                      } else if (continuingStreak) {
                        colIndex = lastColIndex!;
                        
                      } else if (colIndexByShowX.has(rawX)) {
                        colIndex = colIndexByShowX.get(rawX)!;
                        
                      } else {
                        colIndex = nextColIndex++;
                        colIndexByShowX.set(rawX, colIndex);
                        
                      }

                      // Ưu tiên outcome từ backend
                      let inferred: 'B' | 'P';
                      if (outcome === 'B' || outcome === 'P') {
                        inferred = outcome;
                      } else if (lastType == null) {
                        inferred = 'B';
                      } else {
                        inferred = (lastColIndex !== null && colIndex !== lastColIndex) ? (lastType === 'B' ? 'P' : 'B') : lastType;
                      }

                      // Edge-lock activation on streak change
                      const rowOccupied = (c: number, r: number) => occupied.has(`${c},${r}`);
                      if (lastType !== null && inferred !== lastType) {
                        let pref: number | null = null;
                        if (rowOccupied(colIndex, rows - 1)) pref = rows - 2; else if (rowOccupied(colIndex, rows - 2)) pref = rows - 3; else if (rowOccupied(colIndex, rows - 3)) pref = rows - 4; else if (rowOccupied(colIndex, rows - 4)) pref = rows - 5; else if (rowOccupied(colIndex, rows - 5)) pref = rows - 6; else pref = null;
                        if (pref !== null) {
                          edgeLockActive = true;
                          edgePreferredRow = pref;
                          edgeStartCol = colIndex;
                          edgeStartFilled = false;
                        } else {
                          edgeLockActive = false;
                          edgePreferredRow = null;
                          edgeStartCol = null;
                          edgeStartFilled = false;
                        }
                      }
                      let x = colIndex;
                      let y: number;
                      if (edgeLockActive && edgePreferredRow !== null) {
                        // If clean (no D/E/F) and to the right of start, revert to normal
                        const cleanDEF = !rowOccupied(colIndex, rows - 1) && !rowOccupied(colIndex, rows - 2) && !rowOccupied(colIndex, rows - 3);
                        if (cleanDEF && edgeStartCol !== null && colIndex > edgeStartCol) {
                          edgeLockActive = false;
                        }
                      }
                      if (edgeLockActive && edgePreferredRow !== null) {
                        if (edgeStartCol === colIndex && !edgeStartFilled) {
                          const prevY = (lastYByCol.get(colIndex) ?? -1);
                          y = Math.min(prevY + 1, edgePreferredRow);
                          if (y >= edgePreferredRow) edgeStartFilled = true;
                          while (occupied.has(`${x},${y}`)) { x += 1; }
                        } else {
                          let target = edgePreferredRow;
                          while (target >= 0 && rowOccupied(colIndex, target)) target -= 1;
                          if (target < 0) target = 0;
                          y = target;
                          while (occupied.has(`${x},${y}`)) { x += 1; }
                        }
                      } else {
                        const prevY = (lastYByCol.get(colIndex) ?? -1);
                        y = prevY + 1;
                        if (y >= rows) { y = rows - 1; }
                        while (occupied.has(`${x},${y}`)) { x += 1; }
                      }

                      formatted.push({ x, y, tieCount: 0, type: inferred, isTie: false, colIndex });
                      occupied.add(`${x},${y}`);
                      lastYByCol.set(colIndex, Math.min(y, rows - 1));

                      // update trackers
                      lastType = inferred;
                      lastShowXRaw = rawX;
                      lastColIndex = colIndex;
                    }

                    return formatted;
                  };
                  
                  const computed = formatBaccaratResults(rounds);

                  // Logic phân trang theo khối: mỗi trang 20 cột
                  const maxCol = Math.max(...computed.map((r: any) => r.x), 0);
                  const pageSize = 20;
                  
                  // Tính trang hiện tại dựa trên cột cuối cùng
                  const currentPage = Math.floor(maxCol / pageSize);
                  const startCol = currentPage * pageSize;
                  const endCol = startCol + pageSize;
                  
                  // Lọc dữ liệu cho trang hiện tại
                  const displayData = computed
                    .filter((r: any) => r.x >= startCol && r.x < endCol)
                    .map((r: any) => ({
                      ...r,
                      x: r.x - startCol // Điều chỉnh tọa độ để bắt đầu từ 0
                    }));

                  // (Analytics removed for performance; logs above show placement details.)

                  return (
                    <>
                       <div className="relative w-full h-full">
                         {displayData.map((r: any, idx: number) => {
                          const left = r.x * cellW + cellW / 2;
                          const top = r.y * cellH + cellH / 2;
                          
                          // Backend label bị ngược: "B" là Player (xanh), "P" là Banker (đỏ)
                          let img: string;
                          if (r.type === 'B-H' || r.type === 'P-H') {
                            const variant = r.tieCount >= 3 ? 3 : (r.tieCount >= 2 ? 2 : 1);
                            if (r.type === 'B-H') {
                              img = variant === 1 ? '/assets/B-H.png' : variant === 2 ? '/assets/B-H-2.png' : '/assets/B-H-3.png';
                            } else {
                              img = variant === 1 ? '/assets/P-H.png' : variant === 2 ? '/assets/P-H-2.png' : '/assets/P-H-3.png';
                            }
                          } else if (r.type === 'B') {
                            img = '/assets/B.png';
                          } else {
                            img = '/assets/P.png';
                          }
                          
                          
                          return (
                            <div
                              key={idx}
                              className="absolute w-[16px] h-[16px] sm:w-7 sm:h-7 flex items-center justify-center"
                              style={{ 
                                left: `${(left / baseWidth) * 100}%`, 
                                top: `${(top / baseHeight) * 100}%`, 
                                transform: 'translate(-50%, -50%)' 
                              }}
                            >
                              <img src={img} alt={r.type} className="w-full h-full object-contain" />
                            </div>
                          );
                        })}
                      </div>
                    </>
                  );
                })()}
              </div>

              {/* 4. Title text */}
              <div className="text-center mb-6">
                <h2 className="text-[#FFCA58] text-4xl font-bold">
                  CÔNG THỨC TÍNH CHO RA KẾT QUẢ VÁN NÀY
                </h2>
              </div>

              {/* 5. Button dự đoán */}
              <div className="text-center mb-6">
                <div className={`bg-white px-12 py-6 rounded-lg shadow-lg inline-block mb-4 border-2 ${
                  (() => {
                    const roundFlag = (dataRoom?.percentCurrent?.Round ?? '').toString().toUpperCase();
                    if (roundFlag === 'P') return 'text-blue-500 border-blue-500';
                    return 'text-red-600 border-red-600';
                  })()
                }`}>
                  <div className="text-4xl font-bold">
                    {(() => {
                      const roundFlag = (dataRoom?.percentCurrent?.Round ?? '').toString().toUpperCase();
                      if (roundFlag === 'B') return 'NHÀ CÁI';
                      if (roundFlag === 'P') return 'PLAYER';
                      return (dataRoom?.percentCurrent?.Forecast ?? 0) > 50 ? 'NHÀ CÁI' : 'PLAYER';
                    })()}
                  </div>
                </div>
                <div className="text-white text-3xl font-bold">
                  TỶ LỆ WIN: <span className="text-yellow-400 font-bold text-3xl">
                    {Math.round(dataRoom?.percentCurrent?.Forecast || 0)}%
                  </span>
                </div>
              </div>

              {/* 6. Tổng kết quả gộp chung */}
              <div
                className="text-[#3A2400] p-6 rounded-lg w-full max-w-4xl border-2 border-[#00C3FF]"
                style={{
                  background: 'linear-gradient(to right, #FFF5CB, #FEDE63)',
                }}
              >
                <div className="flex justify-between items-center">
                  {(() => {
                    const martingale = dataRoom?.ai0?.groupRoad ?? dataRoom?.groupRoad ?? tableRound?.groupRoad ?? tableRound;
                    const total = martingale?.total || { group: 0, win: 0, loss: 0 };
                    return (
                      <>
                  <div className="text-center">
                    <div className="font-bold text-lg">TỔNG KẾT QUẢ</div>
                    <div className="text-2xl font-bold text-[#3A2400]">
                      {total.group || 0}(100%)
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="font-bold text-lg">TỔNG VÁN THẮNG</div>
                    <div className="text-2xl font-bold text-green-400">
                      {total.win || 0}(100%)
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="font-bold text-lg">TỔNG VÁN THUA</div>
                    <div className="text-2xl font-bold text-red-400">
                      {total.loss || 0}(0%)
                    </div>
                  </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            </div>

            {/* Right side - Table */}
            <div className="lg:col-span-3">
              <div className="w-full">
                <div
                  className="rounded-lg overflow-hidden border-2 border-[#ffc300]"
                  style={{
                    background: 'linear-gradient(to right, #FFF5CB, #FEDE63)',
                  }}
                >
                  <div
                    className="text-[#674000] p-4 text-center font-bold text-lg"
                  >
                    TỈ LỆ GẤP THÉP 3 TAY QUAY ĐẦU
                  </div>
                  <table className="w-full text-[#000] text-lg">
                      <thead>
                        <tr className="bg-none border-b border-white">
                          <th className="p-4 text-center text-lg font-bold text-[#000]">Vòng</th>
                          <th className="p-4 text-center text-lg font-bold text-[#000]">Tay gấp lose</th>
                          <th className="p-4 text-center text-lg font-bold text-[#000]">Kết quả</th>
                        </tr>
                      </thead>
                    <tbody className="bg-none">
                      {(dataRoom?.ai0?.groupRoad?.table ?? dataRoom?.groupRoad?.table ?? tableRound?.groupRoad?.table ?? tableRound?.table)?.map((value: any, i: number) => (
                        <tr key={i}>
                          <td className="p-4 text-center text-lg" style={{color:"#000"}}>{value.id}</td>
                          <td className="p-4 text-center text-lg" style={{color:"#000"}}>{value.countWin === 0 ? 3 : value.countWin}</td>
                          <td className="text-center text-lg" style={{color:"#000"}}>
                            <span className={`inline-block px-4 py-2 text-sm font-bold rounded-3xl ${value.groupWin ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`}>
                              {value.groupWin ? 'THẮNG' : 'THUA'}
                            </span>
                          </td>
                        </tr>
                      )) || Array.from({ length: 10 }, (_, i) => (
                        <tr key={i}>
                          <td className="p-4 text-center text-lg" style={{color:"#000"}}>-</td>
                          <td className="p-4 text-center text-lg" style={{color:"#000"}}>-</td>
                          <td className="p-4 text-center text-lg text-gray-400" style={{color:"#000"}}>-</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
         )}
       </div>

       {/* Prediction Overlay */}
       {showPredictionOverlay && (
         <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
           <div className="bg-white rounded-lg p-8 max-w-md mx-4 animate-pulse">
             <div className="text-center">
               <div className="text-2xl font-bold text-gray-800 mb-4">
                 DỰ ĐOÁN CHO VÁN TIẾP THEO
               </div>
               <div className="mb-6">
                 {predictionType === 'B' ? (
                   <img 
                     src="/assets/banker.gif" 
                     alt="Banker" 
                     className="w-32 h-32 mx-auto object-contain"
                   />
                 ) : (
                   <img 
                     src="/assets/player.gif" 
                     alt="Player" 
                     className="w-32 h-32 mx-auto object-contain"
                   />
                 )}
               </div>
               <div className="text-3xl font-bold text-red-600 mb-2">
                 {predictionType === 'B' ? 'NHÀ CÁI' : 'PLAYER'}
               </div>
               <div className="text-lg text-gray-600">
                 Tỷ lệ thắng: {Math.round(dataRoom?.percentCurrent?.Forecast || 0)}%
               </div>
             </div>
           </div>
         </div>
       )}

       <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default LobbyRoom;